import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import { BackButton, Form, Header } from 'shared/components'
import { useCouponValidationSchema } from 'features/coupons/hooks/useCouponValidationSchema'
import { CouponFormSections } from 'features/coupons/organisms/CouponForm/CouponFormSections'
import { toCouponPayload } from 'features/coupons/utils/toCouponPayload'
import { useCreateCouponMutation } from './mutations/useCreateCouponMutation'

const CouponAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useCouponValidationSchema()

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { handleSubmit, setError } = form

	const { createCouponMutation, isCreateCouponLoading } = useCreateCouponMutation({
		setError
	})

	const onSubmit = (data: any) => {
		createCouponMutation(toCouponPayload(data) as any)
	}

	return (
		<>
			<Header
				title={t('Add code')}
				eyebrow={t('Booking engine')}
				actions={<BackButton to={routes.couponIndex} text={t('Back to coupons')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Create code')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={isCreateCouponLoading}>
					<CouponFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default CouponAddPage
